/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import classNames from 'classnames';
import { AGENCY_TEXT as TEXT } from '../../support/agencyConstants';
import { ImageService } from '../../../main/services/ImageService/ImageService';
type Props = {
  className?: string;
};
export default class NoAgencyView extends React.PureComponent<Props> {
  render() {
    const { className } = this.props;
    return (
      <div className={classNames('flex-layout__screen', className)}>
        <div className="forbidden-view__container">
          <img className="forbidden-view__image" src={ImageService.getImageUrl('/static/images/ic_unavailablePage.svg')} />
          <div className="forbidden-view__title">{TEXT.NO_AGENCY_SCREEN.TITLE}</div>
          {!this.props.loading && (
            <div>
              <span>{TEXT.NO_AGENCY_SCREEN.BODY}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}
